// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__GZ8nq","circle":"Loader_circle__To5tq","shadow":"Loader_shadow__rPRU0"};